type AssertNotEmpty = <T>(value: Ref<T | null | undefined>, error: () => Error) => asserts value is Ref<T>;

export const assertNotEmpty: AssertNotEmpty = (value, error) => {
  if (value.value === null || value.value === undefined) throw error();
};
